import { combineReducers } from "redux";
import project from "./ProjectModule/project";
import user from "./UserModule/user";
import organization from "./OrganizationModule/organization";
import dashboard from "../Slices/dashboardReducer";
import auth from "../Slices/authReducer";

const rootReducer = combineReducers({
  user,
  project,
  organization,
  dashboard,
  auth,
});

export default rootReducer;
